import { useState } from "react";
import styles from "./styles.module.css";
import { AiOutlineMenu } from "react-icons/ai";
import { useHistory } from "react-router-dom";

function Navbar() {

    let history = useHistory();

    const [click, setClick] = useState(false);

    const handleClick = () => setClick(!click);

    function handleClickQuemSomos(e) {
        history.push('/quemsomos');
    }

    function handleClickContato(e) {
        history.push('/contato');
    }

    function handleClickHome(e) {
        history.push('/');
    }

    function handleClickBolos(e) {
        history.push('/bolos');
    }

    function handleClickDoces(e) {
        history.push('/doces');
    }
    function HandleClickTortas(e) {
        history.push('/tortas');
    }
    function handleClickDiversos(e) {
        history.push('/diversos');
    }

    function renderLi() {
        return (
            <>
                <li className={styles.itens}>
                    <input type="button"
                        value="QUEM SOMOS"
                        className={styles.link}
                        onClick={(e) => handleClickQuemSomos(e)}
                    />
                </li>
                <li className={styles.itens}>
                    <input type="button"
                        value="BOLOS"
                        className={styles.link}
                        onClick={(e) => handleClickBolos(e)}
                    />
                </li>
                <li className={styles.itens}>
                    <input type="button"
                        value="DOCES"
                        className={styles.link}
                        onClick={(e) => handleClickDoces(e)}
                    />
                </li>
                <li className={styles.itens}>
                    <input type="button"
                        value="TORTAS"
                        className={styles.link}
                        onClick={(e) => HandleClickTortas(e)}
                    />
                </li>
                <li className={styles.itens}>
                    <input type="button"
                        value="DIVERSOS"
                        className={styles.link}
                        onClick={(e) => handleClickDiversos(e)}
                    />
                </li>
                <li className={styles.itens}>
                    <input type="button"
                        value="CONTATO"
                        className={styles.link}
                        onClick={(e) => handleClickContato(e)}
                    />
                </li>

            </>
        )
    }

    function renderMenu() {
        if (click) {
            return (
                <ul className={styles.menumobile}>
                    {renderLi()}
                </ul>
            )
        }
    }

    function renderMobileMenu() {
        return (
            <div className={styles.dropdown}>
                {renderMenu()}
            </div>
        )
    }

    return (
        <>
            <nav className={styles.navbar}>
                <div className={styles.logos} onClick={(e) => handleClickHome(e)}>
                    <img className={styles.logo} src="/images/logo.png" alt="NANDA CONFEITOS LOGO"></img>
                    <img className={styles.img} src="/images/nome.png" alt="NANDA CONFEITOS IMG"></img>
                </div>
                <ul className={styles.navmenu}>
                    {renderLi()}
                </ul>
                <div className={styles.icon} onClick={handleClick}>
                    <AiOutlineMenu color="white" size='50' />
                </div>
                {renderMobileMenu()}
            </nav>
        </>
    )
}

export default Navbar;